var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.06,
    y1: 8.06,
    x2: 55.41,
    y2: 55.94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55.94,
    y1: 8.06,
    x2: 8.59,
    y2: 55.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCancelIcon);
export default __webpack_public_path__ + "static/media/menu-cancel-icon.495fee43d72734176787faa459dec77f.svg";
export { ForwardRef as ReactComponent };